import { createStyles, keyframes } from "antd-style";
import { getConfigValue } from "@rumble-it/common-lib/src/config";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const useStyles = createStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 0",
  },
  logo: {
    width: 70,
    animation: `${spin} 2s linear infinite`,
  },
}));

export function LogoSpinner() {
  const { styles } = useStyles();

  return (
    <div className={styles.container}>
      <img
        src={`${getConfigValue("cdnUrl")}/static/assets/rumble/rumble-logo-circle.svg`}
        alt="Bezig met laden..."
        className={styles.logo}
      />
    </div>
  );
}
